import React from 'react'
import Manager from '../../public/components/Manager'
import ShiftDiv from '../SysManage/ShiftDiv'
Ext.require('Ext.Toast')

const config = {
    tabs: {
        '班别': {
            buttons: [
                { text: '添加...', handler: ({ showDetail, refreshPage }) => showDetail(props => <ShiftDiv {...props} id={0} />) },
            ],
            columns: [
                { _text: '班别', field: 'ParaValue0', minWidth: 150, locked: false, flex: 2, search: true },
                { _text: '上午', field: 'ParaValue1', minWidth: 150, flex: 2, filter: true },
                { _text: '下午', field: 'ParaValue2', minWidth: 150, flex: 2, filter: true },
            ],
            onDoubleTap: ({ showDetail, refreshPage }, data) => {
                showDetail(props => <ShiftDiv {...props} id={data.id} />)
            }
        },
    }
}

export default props => <Manager {...props} config={config} />